import React, { useCallback, useEffect, useRef, useState } from 'react'
import cn from 'classnames'

const Button = (props) => {
  return (
    <button
      type="button"
      {...props}
      className={props.classNameOverride || cn('button button-xxl button-dark button-border', props.className)}
    />
  )
}

export function ButtonSelect(props) {
  const elemRef = useRef()
  const { options: _options = [], emptyText = 'Any', value, onChange, onOpenChange } = props
  const [open, setOpen] = useState(false)
  const options = !value ? _options.filter((option) => option.value !== null) : _options
  const option = options.find((o) => o.value === value)
  const index = options.indexOf(option)
  const beforeItems = !option ? [] : [...options].slice(0, index)
  const afterItems = !option || index >= options.length - 1 ? [] : [...options].slice(index + 1)

  const toggleOpen = useCallback(() => {
    const v = !open
    setOpen(v)
    onOpenChange(v)
  }, [open])

  const selectOption = useCallback((v) => {
    onChange(v)
    setOpen(false)
    onOpenChange(false)
  }, [])

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (open && elemRef.current && !elemRef.current.contains(e.target)) {
        setOpen(false)
        onOpenChange(false)
      }
    }
    document.addEventListener('click', handleDocumentClick)
    return () => {
      document.removeEventListener('click', handleDocumentClick)
    }
  }, [open])

  return (
    <>
      <div ref={elemRef} className={cn('button-select', open && 'exempt-from-fade', props.wrapperClassName)}>
        {beforeItems.length > 0 && (
          <div className={cn('button-select-list button-select-list-above', { open })}>
            {beforeItems.map((o) => (
              <Button key={o.value} onClick={() => selectOption(o.value)}>
                {o.text}
              </Button>
            ))}
          </div>
        )}
        <Button onClick={() => toggleOpen()} className="display-block" style={{ opacity: !option && open ? 0 : 1 }}>
          {option ? option.text : emptyText}
        </Button>
        {afterItems.length > 0 && (
          <div className={cn('button-select-list button-select-list-below', { open })}>
            {afterItems.map((o) => (
              <Button key={o.value} onClick={() => selectOption(o.value)}>
                {o.text}
              </Button>
            ))}
          </div>
        )}
        {!option && (
          <div className={cn('button-select-list button-select-list-center', { open })}>
            {options.map((o) => (
              <Button key={o.value} onClick={() => selectOption(o.value)}>
                {o.text}
              </Button>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
